module.exports = __webpack_public_path__ + "upload-es2015.f27be40879b3c089bb94.worker.js"